<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="续费提醒" name="renewRemind">
        <renewRemind :visible="activeName === 'renewRemind'"></renewRemind>
      </el-tab-pane>
      <el-tab-pane
        label="续费记录"
        name="renewalRecord"
        v-if="showRenewalRecord"
      >
        <renewal-record
          :visible="activeName === 'renewalRecord'"
        ></renewal-record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import renewRemind from "./renewalRemind/index.vue";
import renewalRecord from "./renewalRecord/index.vue";
import { staffCheckApi } from "@/api/makeUpLessons";
export default {
  components: {
    renewRemind,
    renewalRecord,
  },
  data() {
    return {
      activeName: "renewRemind",
      showRenewalRecord: false,
    };
  },
  created() {
    if (this.$route.query.from === "renewal") {
      this.activeName = "renewalRecord";
    } else {
      let pageCache = sessionStorage.getItem("teach-renew-manage-page-cache");
      if (pageCache) {
        let pageCacheJSON = JSON.parse(pageCache);
        if (pageCacheJSON.tab) {
          this.activeName = pageCacheJSON.tab;
        }
      }
    }
    staffCheckApi({
      api_path: ["/api/v1/student/course/renew_record_list"],
    }).then((res) => {
      if (res.error_code === 0) {
        this.showRenewalRecord = res.data[
          "/api/v1/student/course/renew_record_list"
        ]
          ? true
          : false;
      }
    });
  },
  methods: {
    handleClick() {
      sessionStorage.setItem(
        "teach-renew-manage-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
